export default __webpack_public_path__ + "static/media/032AB20C-843A-422B-93B1-2B6899E0BA2F_1_105_c.06387cf9.jpeg";